<div class="flex flex-col items-center text-center p-6 mt-32">
    <div class="mb-6">
        <img src="/img/forbidden_access.jpg" alt="Forbidden Access" class="h-60 w-60">
    </div>

    <h1 class="text-[18px] md:text-[22px] lg:text-[32px] font-bold uppercase text-[#152c65] mb-2">{{forbiddenAccessKeys.FORBIDDEN_ACCESS_TITLE | translate }}</h1>
    <p class="text-gray-600 mb-6">
        {{forbiddenAccessKeys.FORBIDDEN_ACCESS_MESSAGE | translate }}
    </p>

    <div class="justify-center flex flex-col sm:flex-row gap-3 w-full">
        <p-button [label]="forbiddenAccessKeys.FORBIDDEN_ACCESS_BACK_TO_PREVIOUS_PAGE | translate" icon="pi pi-arrow-left"
            styleClass="p-button-outlined p-button-secondary w-full" (onClick)="goBack()">
        </p-button>
        <p-button [label]="forbiddenAccessKeys.FORBIDDEN_ACCESS_BACK_TO_HOME | translate" icon="pi pi-home"
            styleClass="p-button-primary w-full" (onClick)="goHome()">
        </p-button>
    </div>
</div>